import { SearchApi } from 'ctp-search-device';
import { CommandApi as DeviceStateApi } from 'ctp-state';
import { DefaultApi as DeviceObuTrackerApi } from 'ctp-obu-tracker';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const accessConfig = {
  apiKey: () => userManager.getApiKey(), // without this --> 401
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

export const deviceSearchApiCaller = new SearchApi(accessConfig, routes.apiRoutes.basePath);
export const deviceStateApiCaller = new DeviceStateApi(accessConfig, routes.apiRoutes.basePath);
export const deviceObuTrackerApiCaller = new DeviceObuTrackerApi(accessConfig, routes.apiRoutes.basePath);
